import auth from "@/services/AuthService";

export default defineNuxtPlugin((nuxtApp) => {
  const apiFetch = $fetch.create({
    baseURL: import.meta.env.VITE_API_ENDPOINT,
    async onRequest({ options }) {
      options.headers.set("Content-Type", "application/vnd.api+json");
      options.headers.set("Accept", "application/vnd.api+json");
      if (import.meta.env.SSR !== true) {
        if (auth.isUserLogged()) {
          options.headers.set("Authorization", `Bearer ${auth.getToken()}`);
        }
      }
    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo("/login"));
      }
    },
    async onResponse(_res) {
      // console.log("res", _res.response._data);
    },
  });

  return {
    provide: {
      apiFetch,
    },
  };
});
